export enum TRANSFER_STATUS_TYPES {
  pending = 'pending',
  executing = 'executing',
  executed = 'executed',
  executed_with_errors = 'executed_with_errors',
  canceled = 'canceled',
}

export interface ITransferResponse {
  amount: number;
  contract_id: string;
  external_id: string;
  source_account_id: string;
  status: TRANSFER_STATUS_TYPES;
  target_account_id: string;
}

export interface ITransfer {
  amount: number;
  contractId: string;
  externalId: string;
  sourceAccountId: string;
  status: TRANSFER_STATUS_TYPES;
  targetAccountId: string;
}

export class TransferViewModel implements ITransfer {
  static fromJSON(json: ITransferResponse): TransferViewModel {
    return new TransferViewModel(
      json.amount,
      json.contract_id,
      json.external_id,
      json.source_account_id,
      json.status,
      json.target_account_id,
    );
  }

  constructor(
    public amount: number,
    public contractId: string,
    public externalId: string,
    public sourceAccountId: string,
    public status: TRANSFER_STATUS_TYPES,
    public targetAccountId: string,
  ) {}
}
